<template>
  <div id="mainDiv">
    <p id="newProject">Create New Project</p>
    <form @submit="addProject" autocomplete="off">
      <table id="table">
        <tr>
          <td><label id="projTitle" for="title_in">Project Title:</label></td>
          <td><input type="text" v-model="title_in" id="title_in" name="title_in" /></td>
        </tr>
        <tr>
          <td><label id="textTitle" for="text_in">Text:</label></td>
          <!-- TODO: add option to clear text select -->
          <td >
            <select v-model="text_in" id="text_in" name="text_in" >
              <option disabled value="">Select Text:</option>
            </select>
          </td>
        </tr>
        <!-- TODO: add text preview -->
        <tr>
          <td><label id="newText">OR Add A New Text:</label></td>
          <td>
            <form  action="/action_page.php">
              <input type="file" id="myFile" @change="addText" name="filename" accept="image/*">
            </form>
          </td>
        </tr>
        <!-- TODO: add way to clear question select -->
        <tr>
          <td><label id="guideQuestion" for="question_existing_in">Guiding Question Template</label></td>
          <td><select v-model="question_existing_in" id="question_existing_in" name="question_existing_in">
              <option disabled value="">Select A Template:</option>
              </select>
          </td>
        </tr>
        <tr>
          <td><label id="ownQuestion" for="question_in">OR Create Your Own Question:</label></td>
          <td><input type="text" v-model="question_in" id="question_in" name="question_in" /></td>
        </tr>
        <tr>
          <td><label id="customEvent">Customize Event Fields:</label></td>
        </tr>

      </table>
      <table id="innerTable">
          <div>
          <tr>
            <td><p id="eventName">Event Name</p></td>
          </tr>
          </div>
          <div>
          <tr>
            <td><p id="startDate">Start Date</p></td>
            <td><p id="endDate">End Date</p></td>
            <td><p id="endDate">Duration</p></td>
          </tr>
          <EventFieldInput v-on:add-field="addField" v-on:remove-field="removeField" :fields="fields" />
          </div>
        </table>
      <input id="createButton" type="submit" value="Create Project" class="button"/>
    </form>
    <!-- <TextList v-bind:text_items="text_items"/>
    <CreateText /> -->
  </div>
</template>

<script>
// import TextList from '@/components/TextList.vue'
// import CreateText from '@/components/CreateText.vue'
import EventFieldInput from '@/components/EventFieldInput.vue'

export default {
  name: 'CreateProject',
  components: {
    // TextList,
    // CreateText,
    EventFieldInput
  },
  data() {
    return {
      question_items: [],
      text_items: [],
      title_in: '',
      text_in: '',
      question_existing_in: '',
      question_in: '',
      fields: []
    }
  },
  created() {
    this.getQuestions();
    this.getTexts();
  },
  methods: {
    async addText(e) { // TODO: restrict to certain file types
      e.preventDefault();
      this.text_in = e.target.files || e.dataTransfer.files;
      this.text_items.push(this.text_in);

      if (!this.text_in) {
        alert("Please select a text");
      }

      let reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = async function() {
        var base64result = reader.result.split(',')[1];

        var fileObj  = {
          'title'            : e.target.files[0].name,
          // 'size'             : e.target.files[0].size,
          // 'type'             : e.target.files[0].type,
          'text'             : base64result
        };

        console.log(fileObj);

        const res = await fetch('api/createtext/', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(fileObj)
        });

        let result = (await res.json());

        if (result.success) {
          var selectBox = document.getElementById('text_in');
          selectBox.options.add(new Option(result.text.title, result.text.id, false));
        } else {
          alert(result.error);
        }
      };
    },
    async getQuestions() {
      let res = await fetch("/api/questions/", {
        credentials: 'include'
      });
      let jsonObj = (await res.json());

      if (!jsonObj.success) {
        if (jsonObj.error == "You're not logged in") {
          this.$router.push('/login');
        } else {
          alert(jsonObj.error);
        }
      } else {
        this.question_items = jsonObj.questions;

        var selectBox = document.getElementById('question_existing_in');

        for (var i = 0; i < this.question_items.length; i++) {
          selectBox.options.add(new Option(this.question_items[i].question, this.question_items[i].id, false));
        }
      }
    },
    async getTexts() {
      let res = await fetch("/api/texts/", {
        credentials: 'include'
      });
      let jsonObj = (await res.json());

      if (!jsonObj.success) {
        if (jsonObj.error == "You're not logged in") {
          this.$router.push('/login');
        } else {
          alert(jsonObj.error);
        }
      } else {
        this.text_items = jsonObj.texts;

        var selectBox = document.getElementById('text_in');

        for (var i = 0; i < this.text_items.length; i++) {
          selectBox.options.add(new Option(this.text_items[i].title, this.text_items[i].id, false));
        }
      }
    },

    async addProject(event) {
      event.preventDefault();

      if (!this.title_in || !this.text_in || (!this.question_existing_in && !this.question_in)) {
        alert("You need to provide a title, text, and question");
      } else {
        let messagebody = null;

        if (this.question_in) {
          messagebody = JSON.stringify({title: this.title_in, text_id: this.text_in, new_question: this.question_in, event_fields: this.fields});
        } else {
          messagebody = JSON.stringify({title: this.title_in, text_id: this.text_in, question_id: this.question_existing_in, event_fields: this.fields});
        }

        const res = await fetch('api/createproject/', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          },
          body: messagebody
        });

        let result = (await res.json());

        if (result.success) {
          this.$router.push('/teacher');
        } else {
          alert(result.error);
        }
      }
    },
    addField(field) {
      this.fields.push(field);
    },
    removeField(index) {
      this.fields.splice(index, 1);
    }
  }

}
</script>
<style scoped>

#mainDiv{
  width: 100%;
}

#newProject{
  font-size: large;
  font-weight: bold;
}

#table{
  margin-left: auto;
  margin-right: auto;
}

#projTitle, #textTitle, #newText, #guideQuestion,
#ownQuestion, #customEvent{
  font-weight: 500;
}

#createButton{
  background-color: var(--block-orange);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 2px;
  margin-top: 10px;
  border: none;
  font-size: medium;
}

#addTextButton{
  background-color: var(--block-orange);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 2px;
  border: none;
  cursor: pointer;
}

#createButton.button:hover{
  cursor: pointer;
}

#eventName, #endDate, #startDate{
  margin-top: 4px;
  margin-bottom: 4px;
  color: white;
  margin-left: 4px;
  font-weight: 500;
}

#innerTable{
  background-color: var(--form-blue);
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-top: 8px;

}

</style>
